var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertBannerStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3554 3.38005L12.0586 1.26217L12.7618 3.38005C13.9973 7.1008 16.9429 10.0173 20.6963 11.24L22.8213 11.9322L20.6963 12.6245C16.9429 13.8471 13.9973 16.7636 12.7618 20.4844L12.0586 22.6023L11.3554 20.4844C10.1199 16.7636 7.17427 13.8471 3.4209 12.6245L1.29586 11.9322L3.4209 11.24C7.17427 10.0173 10.1199 7.1008 11.3554 3.38005Z",
    fill: "#FACC81",
    stroke: "#193676",
    strokeWidth: 0.795479
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertBannerStar);
export default __webpack_public_path__ + "static/media/expert-banner-star.cd18e36ae062420c5426eae0cc11ecb9.svg";
export { ForwardRef as ReactComponent };